import { useState, useEffect } from 'react';
import { PolarChart } from '../Charts/PolarArea';
import { RadarChart } from '../Charts/Radar';
import { getAnnotationStats } from '../../api/annotations';

export const Overview = () => {

    const initAnnotationsStats = {
        "accept": { hours: "", audios: "" }, "reject": { hours: "", audios: ""}, "ignore": { hours: "", audios: ""}
    }

    const [totalAnnotations, setTotalAnnotations] = useState(initAnnotationsStats)
    const [userLabels, setUserLabels] = useState([])
    const [userValues, setUserValues] = useState([])

    useEffect(() => {
        async function fetchData() {
            try {
                const data = await getAnnotationStats()
                const labels = data.user_annotations.map((user: any) => user.annotator) 
                const hours = data.user_annotations.map((user: any) => user.hours) 
                setTotalAnnotations(data.total_annotations)
                setUserLabels(labels)
                setUserValues(hours)
            } catch (err) {
                if (err instanceof Error) {
                    console.log(err.message)
                }
            }
        }
        fetchData()
    }, []);

    const audiosLabelPieChart = ['Audios Accepted', 'Audios Rejected', 'Audios Ignored']

    return (
        <>
             <div className="container px-16 py-20 mx-auto">
             <div className="flex flex-wrap -m-4">
             <div className="md:p-8 p-6 bg-white shadow-xl rounded-lg flex justify-between dark:bg-gray-800 md:items-center md:flex-row flex-col gap-12 m-4">
                    <div>
                    <span className="text-bold text-3xl text-gray-700 dark:text-gray-400 block">
                        Total Annotations Accepted
                    </span>
                    <span className="text-green-500 text-7xl md:text-8xl mt-2 font-black block">
                        { totalAnnotations.accept.hours } h
                    </span>
                </div>
            </div>

            <div className="md:p-8 p-6 bg-white shadow-xl rounded-lg flex justify-between dark:bg-gray-800 md:items-center md:flex-row flex-col gap-12 m-4">
                    <div>
                    <span className="text-bold text-3xl text-gray-700 dark:text-gray-400 block">
                        Total Annotations Rejected
                    </span>
                    <span className="text-red-500 text-7xl md:text-8xl mt-2 font-black block">
                        { totalAnnotations.reject.hours } h
                    </span>
                </div>
                    </div>
            
             <div className="md:p-8 p-6 bg-white shadow-xl rounded-lg flex justify-between dark:bg-gray-800 md:items-center md:flex-row flex-col gap-12 m-4">
                    <div>
                    <span className="text-bold text-3xl text-gray-700 dark:text-gray-400 block">
                        Total Annotations Ignored
                    </span>
                    <span className="text-gray-500 text-7xl md:text-8xl mt-2 font-black block">
                        { totalAnnotations.ignore.hours } h
                    </span>
                </div>
            </div>
                </div>
            </div>
            <div className="w-full lg:flex items-center">

                <div className="w-full">
                    <span className="text-bold font-black text-3xl text-gray-700 dark:text-gray-400 block py-10 pl-48">
                        # of Annotated Audios
                    </span>
                    <PolarChart labels={ audiosLabelPieChart } values={ [totalAnnotations.accept.audios, totalAnnotations.reject.audios, totalAnnotations.ignore.audios] }></PolarChart>
                </div>
            <div className="w-full">
                    <span className="text-bold font-black text-3xl text-gray-700 dark:text-gray-400 block py-10 pl-48">
                        Annotators by hours
                    </span>
                    <PolarChart labels={ userLabels } values={ userValues }></PolarChart>
                </div>
            </div>
        </>
    );
};

